/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */
import {
  DataGrid,
  GridColDef,
  GridPagination,
  gridPageCountSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";

import {
  Alert,
  Box,
  Button,
  Card,
  Checkbox,
  Drawer,
  Grid,
  IconButton,
  LinearProgress,
  Paper,
  Snackbar,
  Stack,
  TablePaginationProps,
  Tooltip,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { AppDispatch, RootState } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../Loader/Loader";
import { useEffect, useRef, useState } from "react";
import React from "react";
import "./HoneywellUserInfo.scss";
import MuiPagination from "@mui/material/Pagination";
import { IErrorProps, Role, UserDto } from "../../models";
import TuneIcon from "@mui/icons-material/Tune";
import QuickSearchToolbar from "../SharedComponents/QuickSearchToolbar";
import updateErrorList from "../../utils/methods/updateErrorList";
import DialogForError from "../SharedComponents/DialogForError";
import ToastBarForError from "../SharedComponents/ToastBarForError";
import { userActions } from "../../store/User/user-slice";
import classes from "./FilterOption.module.css";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import {
  getUserExportListBasedOnForgeCustomerId,
  getUserListBasedOnForgeCustomerId,
  getUserPermissions,
} from "../../store/User/user-actions";
import image from "../../images/Download_icon.png";
import UserPermissions from "../../models/apiModels/UserPermissions";
import * as XLSX from "xlsx";
import RefreshIcon from "@mui/icons-material/Refresh";
import { getNoRowsLabel } from "../../utils/methods/getNoRowsLabel";
import { tenantActions } from "../../store/Tenant/tenant-slice";
import getTenantUsersBasedOnSearchandFilter from "../../utils/methods/getTenantUsersBasedOnSearchandFilter";

type Anchor = "filter";

function HoneywellUserPage() {
  const dispatch: AppDispatch = useDispatch();
  const [searchText, setSearchText] = useState("");
  const toastErrors = useRef<IErrorProps[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isUserLoading, setUserLoading] = useState(false);
  const [errorList, setErrorList] = useState<Array<IErrorProps>>([]);
  const [errorGetUsers, setErrorGetUsers] = useState<Array<IErrorProps>>([]);
  const [errorExport, seterrorExport] = useState<Array<IErrorProps>>([]);
  const [openDialogNoURLError, setOpenDialogNoURLError] = useState(false);
  const [openDialogServerError, setOpenDialogServerError] = useState(false);
  const [openToastError, setOpenToastError] = useState(false);

  // Export related states
  const [progress, setProgress] = useState(0);
  const [toastOpen, settoastOpen] = useState(false);

  const navigate = useNavigate();

  const userData = useSelector((state: RootState) => state.user.users);
  const [gridData, setGridData] = useState<Array<UserDto>>([]);
  const [filteredUsers, setFilteredUsers] = useState<Array<UserDto>>(
    useSelector((state: RootState) => state.user.users)
  );
  const [filteredRoles, setFilteredRoles] = useState<string[]>([]);

  //Filter Constants
  const [state, setState] = React.useState({
    filter: false,
  });

  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [listofRoles, setListofRoles] = useState<
    [
      {
        role: Role;
        count: any;
      }
    ]
  >();

  const [refreshKey, setRefreshKey] = useState(0);

  const userPermissionFetched = useSelector(
    (state: RootState) => state.user.isUserPermissionsFetched
  );

  const userPermissions: UserPermissions = useSelector(
    (state: RootState) => state.user.userPermissions
  );

  const currentTenantIdOfLoadedUsers = useSelector(
    (state: RootState) => state.cart.currentTenantIdOfLoadedUsers
  );
  //checkbox of user listpage
  // istanbul ignore next
  const handleCheckboxChange = (option: string) => {
    if (selectedOptions.includes(option)) {
      setSelectedOptions(selectedOptions.filter((item) => item !== option));
    } else {
      setSelectedOptions([...selectedOptions, option]);
    }
  };

  const handleCancel = () => {
    setSelectedOptions(filteredRoles);
    setState({ filter: false });
  };

  const handleClear = () => {
    setSelectedOptions([]);
  };
  // Handle submit of user page
  // istanbul ignore next
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    // logic to handle get search data before

    const filteredusersData: UserDto[] = userData.filter((item: UserDto) => {
      return item.roles.some(
        (role: Role) =>
          selectedOptions.length === 0 || selectedOptions.includes(role?.name)
      );
    });

    const searchedUsers = getTenantUsersBasedOnSearchandFilter(
      filteredusersData,
      searchText
    );

    setGridData(searchedUsers);

    setFilteredUsers(filteredusersData);
    setFilteredRoles(selectedOptions);
    setState({ ...state, filter: false });
  };

  const toggleDrawer =
    (anchor: Anchor, open: boolean) =>
    (event: React.KeyboardEvent | React.MouseEvent) => {
      setState({ ...state, [anchor]: true });
    };

  const list = (anchor: Anchor) => (
    <Box
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    ></Box>
  );
  //Filter End

  useEffect(() => {
    if (currentTenantIdOfLoadedUsers !== "honeywell") {
      dispatch(userActions.resetUserListBasedOnForgeCustomerId());
    }

    //If user permissions are not fetched Fetch the permissions
    //For Logged in User before performing any action
    // istanbul ignore next
    if (!userPermissionFetched) {
      setIsLoading(true);
      dispatch(getUserPermissions())
        .unwrap()
        .then((response) => {
          const userPermissionsResponse: UserPermissions = response.result;
          if (userPermissionsResponse.can_read_honeywell_user) {
            // If currently users are loaded for "Honeywell" tenant i.e Admin tenant,
            // Then no need to reload the users of "honeywell" instead get the users from the store
            if (currentTenantIdOfLoadedUsers !== "honeywell") {
              setUserLoading(true);
              dispatch(getUserListBasedOnForgeCustomerId("honeywell"))
                .unwrap()
                .then((response) => {
                  // Set current tenant to be "honeywell".
                  // Needed to add this as Honeywell users can be viewed from
                  // 1) Honeywell User page directly
                  // 2) From Tenant user page
                  // So, we need to reset the current tenant whose users are loaded
                  dispatch(
                    tenantActions.getCurrentTenantIdOfLoadedUsers("honeywell")
                  );
                })
                .catch((err: any) => {
                  setErrorGetUsers(updateErrorList(err, [...errorGetUsers]));
                })
                .finally(() => setUserLoading(false));
            }
          } else {
            handleError_IfPrivilegeNotPresentForUser(
              "User doesn't have privileges to List the UDP Admin Users"
            );
          }
        })
        .catch((err: any) => {
          setErrorGetUsers(updateErrorList(err, [...errorGetUsers]));
          let errorCode = err.status;
          if (errorCode == 401) {
            navigate("/error");
          }
        })
        .finally(() => setIsLoading(false));
    } else {
      if (currentTenantIdOfLoadedUsers !== "honeywell") {
        getHoneywellUserGridDataIfPermissionIsPresent();
      }
    }
  }, []);
  //On change of user data , which will change the data grid values
  // istanbul ignore next
  useEffect(() => {
    setGridData(userData);
    let rolesList: [
      {
        role: Role;
        count: any;
      }
    ] = [
      {
        role: { roleId: "", name: "" },
        count: 0,
      },
    ];
    userData.forEach((user: any, index: any) => {
      user.roles.forEach((roleData: any, index: any) => {
        if (!rolesList.some((item) => item.role.roleId === roleData.roleId)) {
          rolesList.push({ role: roleData, count: 1 });
        } else {
          rolesList.map((roleCountUp) => {
            if (roleCountUp.role.roleId === roleData.roleId) {
              roleCountUp.count = roleCountUp.count + 1;
            }
          });
        }
      });
    });
    rolesList.shift();
    setListofRoles(rolesList);
  }, [userData]);

  useEffect(() => {
    const mergedErrors = [...errorGetUsers, ...errorExport];
    if (
      mergedErrors.some((x) => x.errorCode === undefined) &&
      !openDialogNoURLError
    ) {
      setOpenDialogNoURLError(true);
    }
    if (mergedErrors.some((x) => x.errorCode === 400) && !openToastError) {
      setOpenToastError(true);
    }
    if (
      mergedErrors.some(
        (x) =>
          x.errorCode !== undefined &&
          x.errorCode !== 400 &&
          x.errorCode !== null &&
          x.errorCode !== 204
      ) &&
      !openDialogServerError
    ) {
      setOpenDialogServerError(true);
    }
    setErrorList(mergedErrors);
  }, [errorGetUsers, errorExport]);

  const columns: GridColDef[] = [
    {
      field: "firstName",
      headerName: "NAME",
      flex: 1,
      renderCell: (cellValues: any) => {
        const userInfoDetails = {
          CustomerId: "honeywell",
          UserInfo: cellValues.row,
        };
        const userName =
          cellValues.row.firstName + " " + cellValues.row.lastName;
        return (
          <Tooltip title={userName} placement="bottom-start">
            <Link
              to="/honeywell/user/info"
              state={userInfoDetails}
              style={{ color: "#64C3FF", textDecoration: "none" }}
            >
              {userName}
            </Link>
          </Tooltip>
        );
      },
    },
    { field: "emailId", headerName: "EMAIL ID", flex: 2 },

    {
      field: "roles",
      headerName: "ROLES",
      sortable: false,
      flex: 2,
      renderCell: (cellValues: any) => {
        if (cellValues && cellValues.row && cellValues.row.roles) {
          return cellValues.row.roles
            .map((x: { name: any }) => x.name)
            .join(",");
        } else {
          return "";
        }
      },
    },

    {
      field: "ACTION",
      flex: 1,
      sortable: false,
      renderCell: (cellValues: any) => {
        function handleEdit(
          event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
          cellValues: any
        ) {
          const userDetailsToEdit = {
            CustomerId: "honeywell",
            UserInfo: cellValues.row,
          };
          if (userPermissions.can_update_honeywell_user) {
            navigate(`/honeywell/user/edit`, {
              state: { userDetailsToEdit },
            });
          } else {
            handleError_IfPrivilegeNotPresentForUser(
              "User doesn't have privileges to Update the UDP Admin Users"
            );
          }
        }

        return (
          <div>
            <Button
              sx={{
                fontSize: "0.7rem",
                padding: 0,
                justifyContent: "start",
                color: "#64C3FF",
                textTransform: "none",
                fontFamily: "Honeywell Sans Web",
              }}
              onClick={(event) => {
                handleEdit(event, cellValues);
              }}
            >
              Edit
            </Button>
          </div>
        );
      },
    },
  ];

  function Pagination({
    page,
    onPageChange,
    className,
  }: Pick<TablePaginationProps, "page" | "onPageChange" | "className">) {
    const apiRef = useGridApiContext();
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    return (
      <MuiPagination
        color="primary"
        className={className}
        count={pageCount}
        page={page + 1}
        onChange={(event, newPage) => {
          onPageChange(event as any, newPage - 1);
        }}
      />
    );
  }

  function CustomPagination(props: any) {
    return <GridPagination sx={{}} ActionsComponent={Pagination} {...props} />;
  }
  const handleError_IfPrivilegeNotPresentForUser = (errorMessage: string) => {
    const error: IErrorProps = {
      errorCode: 403,
      errorMessage: errorMessage,
    };
    const errorList: IErrorProps[] = [];
    errorList.push(error);

    setErrorList(errorList);
    setOpenToastError(true);
    return errorList;
  };

  const handleCreateNewUser = () => {
    if (userPermissions.can_create_honeywell_user) {
      navigate("/honeywell/user/create");
    } else {
      handleError_IfPrivilegeNotPresentForUser(
        "User doesn't have privileges to Create the UDP Admin Users"
      );

      toastErrors.current = [];
    }
  };

  const searchOnchange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(event.target.value);
  };
  const handleCloseToast = () => {
    settoastOpen(false);
  };

  const getHoneywellUserGridDataIfPermissionIsPresent = () => {
    if (userPermissions.can_read_honeywell_user) {
      setUserLoading(true);
      dispatch(getUserListBasedOnForgeCustomerId("honeywell"))
        .unwrap()
        .then(() => {
          // Set current tenant to be "honeywell".
          // Needed to add this as Honeywell users can be viewed from
          // 1) Honeywell User page directly
          // 2) From Tenant user page
          // So, we need to reset the current tenant whose users are loaded
          dispatch(tenantActions.getCurrentTenantIdOfLoadedUsers("honeywell"));
        })
        .catch((err: any) => {
          setErrorGetUsers(updateErrorList(err, [...errorGetUsers]));
        })
        .finally(() => setUserLoading(false));
    } else {
      let errorListData = handleError_IfPrivilegeNotPresentForUser(
        "User doesn't have privileges to List the UDP Admin Users"
      );

      toastErrors.current = errorListData;
    }
  };

  function FilterDrawer({ isFilterDisabled }: { isFilterDisabled?: boolean }) {
    return (
      <div>
        {(["filter"] as const).map((anchor) => (
          <div key={anchor}>
            <Button
              disabled={isFilterDisabled}
              startIcon={
                <TuneIcon
                  sx={{
                    transform: "rotate(90deg)",
                    width: "0.7rem",
                    height: "0.7rem",
                  }}
                />
              }
              sx={{
                color: "#F0F0F0",
                background: "#707070",
                border: "1px solid #707070",
                fontSize: "0.7rem",
                height: "4vh",
                width: "auto",
                paddingRight: "2vw",
                paddingLeft: "2vw",
              }}
              onClick={toggleDrawer(anchor, true)}
            >
              <div style={{ textTransform: "capitalize" }}>{anchor}</div>
            </Button>
            <Drawer
              anchor={"right"}
              open={state[anchor]}
              onClose={toggleDrawer(anchor, false)}
              variant="temporary"
            >
              <Box
                sx={{
                  color: "#F0F0F0",
                  padding: "1vh",
                  backgroundColor: "#272727",
                  height: "100%",
                  marginTop: "4vh",
                  width: "25vw",
                }}
              >
                <Grid container direction="column">
                  <Grid container direction="row">
                    <Grid
                      item
                      width="50%"
                      className={classes.filterHeadingGrid}
                    >
                      <Typography className={classes.filterHeading}>
                        Filter
                      </Typography>
                    </Grid>
                    <Grid container justifyContent="flex-end" width="50%">
                      <Button
                        sx={{
                          width: "0.5vw",
                          justifyContent: "flex-end",
                        }}
                        onClick={handleCancel}
                      >
                        <CloseIcon sx={{ color: "#F0F0F0" }} />
                      </Button>
                    </Grid>
                  </Grid>
                  <Grid container direction="row">
                    <Grid item sx={{ padding: 2 }} className={classes.filterby}>
                      Filter By
                    </Grid>
                    <Grid
                      container
                      justifyContent="flex-end"
                      width="50%"
                      sx={{
                        padding: "1vh",
                      }}
                    >
                      <Button
                        sx={{ padding: 0 }}
                        onClick={handleClear}
                        startIcon={<RestartAltIcon />}
                        className={classes.clearall}
                      >
                        Clear all
                      </Button>
                    </Grid>
                  </Grid>
                  <Grid item className={classes.subHeadingFilter}>
                    {" "}
                    Roles
                    {` (${listofRoles?.length})`}
                  </Grid>
                </Grid>

                <form onSubmit={handleSubmit}>
                  {listofRoles?.map((option) => (
                    <div
                      key={option.role.name}
                      className={classes.optionsCheck}
                    >
                      <Checkbox
                        checked={selectedOptions.includes(option.role.name)}
                        onChange={() => handleCheckboxChange(option.role.name)}
                        inputProps={{ "aria-label": option.role.name }}
                      />
                      {option.role.name} {"("} {option.count} {")"}
                    </div>
                  ))}
                  <Grid
                    container
                    justifyContent="flex-end"
                    direction="row"
                    className={classes.filterButtonGrid}
                    sx={{
                      bottom: "4vh",
                      WebkitAlignContent: "unset",
                    }}
                  >
                    <Grid item width="50%">
                      <Button
                        className={classes.cancelButton}
                        onClick={handleCancel}
                        sx={{ margin: "0.5vw", marginLeft: "2vw" }}
                      >
                        Cancel
                      </Button>
                    </Grid>
                    <Grid container width="50%" justifyContent="flex-end">
                      <Button
                        type="submit"
                        className={classes.filterButtonShow}
                        sx={{ margin: "0.5vw" }}
                      >
                        Show results
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </Box>
              {list(anchor)}
            </Drawer>
          </div>
        ))}
      </div>
    );
  }

  useEffect(() => {
    let searchUsersData: UserDto[] = filteredUsers;
    if (selectedOptions.length > 0) {
      searchUsersData = filteredUsers;
    } else {
      searchUsersData = userData;
    }
    let searchedUsers = getTenantUsersBasedOnSearchandFilter(
      searchUsersData,
      searchText
    );

    setGridData(searchedUsers);
  }, [searchText]);
  //when clicked on download icon
  // istanbul ignore next

  const downloadExcel = async () => {
    setUserLoading(true);
    dispatch(getUserExportListBasedOnForgeCustomerId("honeywell"))
      .unwrap()
      .then(async (data) => {
        settoastOpen(true);
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        let currentDate = new Date().toJSON().slice(0, 10);
        const fileData = XLSX.writeFile(
          workbook,
          `UDP_Admin-User-Management-${currentDate}.xlsx`
        );
        const blob = new Blob([fileData], { type: "application/octet-stream" });
        const url = URL.createObjectURL(blob);
        const response = await fetch(url);
        const contentLength = response.headers.get("content-length") ?? "100";

        const total = parseInt(contentLength, 10);
        const reader = response.body?.getReader();
        if (!reader) {
          URL.revokeObjectURL(url);
          return;
        }

        let loaded = 0;

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;

          loaded += value.length;
          const percent = Math.round((loaded / total) * 100);
          setProgress(percent);
        }
        URL.revokeObjectURL(url);
        // TO-DO : remove the animation for setting value back to zero
        await new Promise((resolve) => setTimeout(resolve, 2500));
        settoastOpen(false);
        setProgress(0);
      })
      .catch((error: any) => {
        seterrorExport(updateErrorList(error, [...errorExport]));
      })
      .finally(() => setUserLoading(false));
  };
  //to remove a specific filter using X icon
  // istanbul ignore next

  const removeFilter = (item: string) => {
    const updateFilterRoles = selectedOptions.filter((x) => x != item);
    setFilteredRoles(updateFilterRoles ?? []);
    setSelectedOptions(updateFilterRoles ?? []);
    let filteredusersData: UserDto[] = userData;
    if (updateFilterRoles.length === 0) {
    } else {
      // Set grid data after filter is changed by clicking close on a filter's close icon
      filteredusersData = userData.filter((item: UserDto) => {
        return item.roles.some((role: Role) =>
          updateFilterRoles.includes(role.name)
        );
      });
    }
    setFilteredUsers(filteredusersData);
    let searchedUsers = getTenantUsersBasedOnSearchandFilter(
      filteredusersData,
      searchText
    );

    setGridData(searchedUsers);
    setRefreshKey((prevKey) => prevKey + 1);
  };

  const customLocaleText = {
    noRowsLabel: getNoRowsLabel(searchText, selectedOptions.length !== 0),
  };
  // End No matching results close
  // Error props handlers
  const onDialogForServerCloseHandler = () => setOpenDialogServerError(false);
  const onDialogForNOURLCloseHandler = () => setOpenDialogNoURLError(false);

  const handleToastBarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenToastError(false);
  };

  // End Error props handlers

  return (
    <main style={{ flexGrow: 1, display: "flex" }}>
      <Paper
        sx={{
          minWidth: "1000px",
        }}
        className="paper"
      >
        <Grid container direction="column" p={2} borderColor={"black"}>
          <Grid
            container
            direction="row"
            sx={{ paddingBottom: "1vh", minWidth: "600px" }}
          >
            <Box className="heading"> UDP Admin </Box>
            <Box marginLeft={2} marginRight={2} sx={{ fontSize: "1rem" }}>
              {" "}
              |{" "}
            </Box>
            <Snackbar
              open={toastOpen}
              onClose={handleCloseToast}
              sx={{ width: "30%" }}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            >
              <Alert
                severity="info"
                onClose={handleCloseToast}
                className={classes.exportToast}
              >
                <Grid item md={12}>
                  <Typography
                    sx={{ width: "200px", padding: " 5 0 5 0" }}
                    className={classes.exportToastMessage}
                  >
                    Datasheet.xslx
                  </Typography>
                  <LinearProgress
                    sx={{
                      width: "100%",
                      borderRadius: "4px 2px 2px 4px",
                      backgroundColor: "#707070",
                    }}
                    variant="determinate"
                    value={progress}
                  />
                  <Typography
                    color="inherit"
                    sx={{ width: "200px" }}
                    className={classes.exportToastMessage}
                  >
                    Downloading...
                  </Typography>
                </Grid>
              </Alert>
            </Snackbar>
            <Box className="totalCount">
              {gridData.length === 1 ? (
                <span>Total 1 User</span>
              ) : (
                <span>Total {gridData.length} Users</span>
              )}
            </Box>
            <Box
              sx={{
                marginLeft: "auto",
                alignItems: "flex-end",
                textAlign: "flex-end",
                paddingRight: "5vh",
              }}
            >
              <Button
                variant="contained"
                sx={{ fontSize: 9 }}
                onClick={handleCreateNewUser}
                className="createuser"
              >
                Create New User
              </Button>
            </Box>
          </Grid>
          <Card
            sx={{
              background: "#272727",
              border: "1px solid #101010",
              boxShadow: " 1px 1px 1px rgba(0, 0, 0, 0.15)",
              borderRadius: "0.7vw",
              minWidth: "600px",
            }}
          >
            <Box
              p="0vh"
              paddingLeft="1.5vw"
              sx={{ background: "#313030", height: "5vh" }}
            >
              {" "}
              <div className="secondaryHeading">Honeywell UDP Users</div>
            </Box>

            <Grid
              item
              sx={{
                background: "#272727",
                border: " 0.1 solid #101010",
                minWidth: "600px",
              }}
            >
              <Grid
                container
                direction="row"
                sx={{ width: "100%", minWidth: "800px" }}
              >
                <Grid
                  item
                  sx={{
                    padding: "1.4vh",
                    paddingTop: "1.9vh",
                  }}
                >
                  <FilterDrawer isFilterDisabled={isUserLoading || isLoading} />
                </Grid>
                <Grid item sx={{ padding: "1.4vh" }}>
                  <QuickSearchToolbar
                    isDisabled={
                      isLoading || isUserLoading || userData?.length === 0
                    }
                    value={searchText}
                    placeHolderMessage="Search User"
                    onChange={(event: any) => searchOnchange(event)}
                  ></QuickSearchToolbar>
                </Grid>
                {/* <Grid width="40%"></Grid> */}
                <Grid
                  p={1}
                  sx={{
                    marginLeft: "auto",
                    alignItems: "flex-end",
                    textAlign: "flex-end",
                    paddingRight: "5vh",
                    height: "1vh",
                    backgroundColor: "#272727",
                  }}
                >
                  <Stack
                    direction="row"
                    spacing={0}
                    sx={{ flexDirection: "row-reverse", height: "5vh" }}
                  >
                    <Tooltip title="Refresh List">
                      <Button
                        className={classes.refreshButton}
                        sx={{ marginTop: "0.5vh", marginBottom: "1vh" }}
                        onClick={() => {
                          getHoneywellUserGridDataIfPermissionIsPresent();
                          setSearchText("");
                          setFilteredRoles([]);
                          setSelectedOptions([]);

                          setRefreshKey((prevKey) => prevKey + 1);
                        }}
                        data-testid="refreshBtn"
                      >
                        <RefreshIcon
                          sx={{
                            color: "#F0F0F0",
                            fontSize: "2vw",
                            paddingTop: 0,
                          }}
                        />
                      </Button>
                    </Tooltip>
                    <Tooltip title="Download list of all users">
                      <Button
                        onClick={() => downloadExcel()}
                        sx={{
                          marginTop: "0.8vh",
                          marginBottom: "1vh",
                        }}
                        data-testid="excelDownload"
                      >
                        <img
                          src={image}
                          alt="Button Icon"
                          style={{
                            width: "2vw",
                            paddingLeft: 0,
                            paddingTop: 0,
                            paddingBottom: 0,
                          }}
                        />
                      </Button>
                    </Tooltip>
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              sx={{
                textAlign: "left",
                background: "#272727",
                border: "1px solid #101010",
                fontSize: "0.2 rem",
                padding: "0.5vh",
                width: "auto",
              }}
            >
              {filteredRoles.length === 0 ? (
                <Grid item className={"nofilter"}>
                  No filters applied
                </Grid>
              ) : (
                filteredRoles.map((item) => (
                  <Grid item className="filterChips">
                    <>
                      {item}
                      <IconButton
                        className={classes.filterCloseIcon}
                        onClick={() => {
                          removeFilter(item);
                        }}
                        data-testid="imageEdit"
                      >
                        <CloseIcon sx={{ fontSize: "0.9rem" }} />
                      </IconButton>
                    </>
                  </Grid>
                ))
              )}
            </Grid>
            <Grid item md={12}>
              <div
                style={{
                  height: "60vh",
                  background: "#272727",
                  fontSize: 8,
                  width: "94vw",
                  minWidth: "800px",
                }}
              >
                <DataGrid
                  key={refreshKey}
                  rowHeight={40}
                  columnHeaderHeight={35}
                  loading={isUserLoading}
                  rows={gridData}
                  pagination
                  slots={{
                    pagination: CustomPagination,
                  }}
                  initialState={{
                    pagination: {
                      paginationModel: { pageSize: 10, page: 0 },
                    },
                  }}
                  columns={columns}
                  autoHeight={false}
                  disableColumnMenu={true}
                  sx={{
                    fontFamily: "Honeywell Sans Web",
                    borderBlockColor: "black",
                    border: "black",
                    borderBlockEndColor: "black",
                    background: "#272727",
                    borderColor: "black",
                    fontSize: "0.8rem",
                    minWidth: "1000px",
                  }}
                  localeText={customLocaleText}
                />
              </div>
            </Grid>
          </Card>
        </Grid>
        {/* </Paper> */}
      </Paper>
      {isLoading && <Loader />}
      {/* // Add Toast
        bar component and pass onClose for alert and open, onClose for snackbar //
        Add Dialog component and pass open, onClose for Dialog */}

      {openDialogServerError && (
        <DialogForError
          open={openDialogServerError}
          onClose={onDialogForServerCloseHandler}
          errorList={errorList}
          errorType="serverError"
        />
      )}
      {/* /// Open NoURL error */}
      {openDialogNoURLError && (
        <DialogForError
          open={openDialogNoURLError}
          onClose={onDialogForNOURLCloseHandler}
          errorList={errorList}
          errorType="noURLFoundError"
        />
      )}
      {/* /// Open Toast error */}
      {openToastError && (
        <ToastBarForError
          open={openToastError}
          onClose={handleToastBarClose}
          errorList={errorList.concat(toastErrors.current)}
        />
      )}
    </main>
  );
}

export default HoneywellUserPage;
